import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Row, Input, Alert, Label, } from "reactstrap";
import moment from "moment";
//import { Button, Accordion, } from "react-bootstrap";

//Import Images
import { AppConfiguration } from "read-appsettings-json";
import { GetRequest, PostRequest } from '../../noser-dataaccess'
import axios from 'axios'
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";


const ShortListed = () => {

    const [listOfJobs, setDlistOfJobs] = useState([]);
    const [mainGrid, setmainGrid] = useState([
        {
            "id":"1",
            "postingId":"1",
            "name":"tasyo",
            "title":"tambay",
            "expectedSalary":"100,000",
            "city":"makati",
            "resume":"",
            "ScheduleInterview":"",
            "action2":"",
        },
        {
            "id":"phr-1-2-3",
            "postingId":"phr-1-2-3",
            "name":"dio",
            "title":"food tester",
            "expectedSalary":"40,000",
            "city":"taguig",
            "resume":"",
            "ScheduleInterview":"",
        }
    ]);
    const [companyProfiles, setcompanyProfiles] = useState([]);
    const [jobPosted, setjobPosted] = useState([]);
    const [search, setsearch] = useState("");
    
    const [isshow, setisshow] = useState("")
    const [color, setcolor] = useState("")
    const [messageAlert, setmessagealert] = useState("")
    const [fade, setfade] = useState("")
    const [alerttype, setalerttype] = useState("")
    const [statusData, setstatusData] = useState([
       
        {
           "id":"1",
           "label":"Hired",
           "value":"Hired"
        },
        {
            "id":"2",
            "label":"Decline",
            "value":"Decline"
        },
        // {
        //     "id":"3",
        //     "label":"keep warm",
        //     "value":"KW"
        // },
        // {
        //     "id":"4",
        //     "label":"shorlisted",
        //     "value":"SL"
        // },
        // {
        //     "id":"5",
        //     "label":"not qualified",
        //     "value":"NQ"
        // },
    ]);
    const [jobRef, setjobRef] = useState("");
    const [pstingDateFilter, setpstingDateFilter] = useState("");
    const [jobPostStatus, setjobPostStatus] = useState("");
    const [jobtitlefilter, setjobtitlefilter] = useState("");
    const [endDateFilter, setendDateFilter] = useState("");
    const [dateHired, setDateHIred] = useState("");



    const rowClasses = 'custom-row-class-success';


    useEffect(() => {
        let companyProfileTmp = JSON.parse(sessionStorage.getItem("CompanyProfile"))
        let userProfileTmp = JSON.parse(sessionStorage.getItem("userCollection"))
        // if(userProfileTmp == 0 || companyProfileTmp == 0){
        //     window.location.href='/EmployerValidation'
        //     return
        // }
       // OnLoadScreen()
        GetCompanyProfile()
        let toEdit = JSON.parse(sessionStorage.getItem("jobPostedEdit"))
        /* if(JSON.parse(sessionStorage.getItem("jobPostedEdit")) !== null){
            GetCandidatesFilterd(toEdit)
        }else{ */
            GetCandidates()
        //}
      
        //GetJobPosted()
    },[]);

    const helperBuildCriteria=()=>{
        

        let _filterData = ""
       
        let _jobRefNo = ""
        let _jobtitle = ""
        let _dateHired = ""
        let _EndDate = ""
        let _status = "" 

        //let transactionDate = (this.state.transactionDate) ? moment(this.state.transactionDate).format('MM/DD/YYYY') : ""
        
        if (jobRef != "" || jobRef !== "") {
            _jobRefNo = "postingId" + ":" + jobRef + ","
        }
        if (endDateFilter != "" || endDateFilter !== "") {
            _EndDate = "endDate" + ":" + endDateFilter + ","
        }
        if (jobtitlefilter != "" || jobtitlefilter !== "") {
            _jobtitle = "title" + ":" + jobtitlefilter + ","
        }
      
        _filterData = _jobRefNo + _status + _jobtitle +  _EndDate
        //// console.log("_transacDate _transacDate _transacDate _transacDate")
        //// console.log(_transacDate)
        return _filterData
    }

    const handleChangeSearch = () => {
        /* if(this.state.payrollDate === ""){
            this.setState(  {
                isloading       :   false,
                alerttype       :   "Warning!",
                isshow          :   true,
                color           :   "warning",
                message         :   "Please select payroll date!",
                fade            :   true
            })
            return
        } */

        let _fdata = helperBuildCriteria()
        let _filterData = _fdata.split(",")
        let _objfd = {}

        let jsonData = {};
        for (let i = 0; i < _filterData.length - 1; i++) { 
            let columnName = _filterData[i].split(":")[0]
            _objfd[columnName] = _filterData[i].split(":")[1];
        }
        // console.log("filter_data")
        // console.log(_objfd)

        GetFilterResult(_objfd);
    }

    const GetFilterResult = async(_objfd) => {

        let filter_data = {}
        let dataTmp = []

        const Params = {
          "_collection" : "Candidates",
          "filter_data" : _objfd
        }
        // console.log("Params GetFilterResult")
        // console.log(Params)
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            let data = res.data
            // console.log("data")
            // console.log(data)
            let newstr2=""
            data.Candidates.map(function(itm,i){
                //// console.log("itm")
                //// console.log(itm)
                let strJson = "{" + itm.substring(46, itm.length)
                let strJson2 = itm.substring(18, itm.length)
                newstr2 = strJson2.split("')")[0]
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                json.headerId = newstr2
                dataTmp.push(json)
            })    
            //// console.log("dataTmp GetCandidates" )
            //// console.log(dataTmp)

            setDlistOfJobs(dataTmp)   
            setmainGrid(dataTmp) 
        })
        .catch(error =>{
            alert("error: " + error)
        })
    }

    const GetCandidatesFilterd = async(toEdit) => {

        let filter_data = {postingId:toEdit.postingId }
        let dataTmp = []

        const Params = {
          "_collection" : "Candidates",
          "filter_data" : filter_data
        }
        //// console.log("Params GetCandidatesFilterd")
        //// console.log(Params)
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            let data = res.data
            //// console.log("data")
            //// console.log(data)
            let newstr2=""
            data.Candidates.map(function(itm,i){
                //// console.log("itm")
                //// console.log(itm)
                let strJson = "{" + itm.substring(46, itm.length)
                let strJson2 = itm.substring(18, itm.length)
                newstr2 = strJson2.split("')")[0]
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                json.headerId = newstr2
                dataTmp.push(json)
            })    
            //// console.log("dataTmp GetCandidates" )
            //// console.log(dataTmp)

            setDlistOfJobs(dataTmp)   
            setmainGrid(dataTmp) 
        })
        .catch(error =>{
            alert("error: " + error)
        })
    }

    const GetCandidates = async() => {

        let filter_data = {"isDeleted": "0","status":"SL" }
        let dataTmp = []

        const Params = {
          "_collection" : "Candidates",
          "filter_data" : filter_data
        }
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            let data = res.data
            //// console.log("data")
            //// console.log(data)
            let newstr2=""
            data.Candidates.map(function(itm,i){
                //// console.log("itm")
                //// console.log(itm)
                let strJson = "{" + itm.substring(46, itm.length)
                let strJson2 = itm.substring(18, itm.length)
                newstr2 = strJson2.split("')")[0]
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                json.headerId = newstr2
                dataTmp.push(json)
            })    
            //// console.log("dataTmp GetCandidates" )
            //// console.log(dataTmp)

            setDlistOfJobs(dataTmp)   
            setmainGrid(dataTmp) 
        })
        .catch(error =>{
            alert("error: " + error)
        })
    }

    const GetCompanyProfile = async() => {
        let filter_data = {"isDeleted": "0", }
        let dataTmp = []
        const Params = {
          "_collection" : "CompanyProfile",
          "filter_data" : filter_data
        }
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            let data = res.data
            let newstr2=""
            data.CompanyProfile.map(function(itm,i){
                let strJson = "{" + itm.substring(46, itm.length)
                let strJson2 = itm.substring(18, itm.length)
                newstr2 = strJson2.split("')")[0]
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                json.headerId = newstr2
                dataTmp.push(json)
            })    

            //// console.log("dataTmp GetCompanyProfile")
            //// console.log(dataTmp)
            setcompanyProfiles(dataTmp)   
          
            
            // setJson(dataTmp)  
            //GetJobPosted(dataTmp); 
        })
        .catch(error =>{
            alert("error: " + error)
        })
    };
    const GetJobPosted = async(dataTmp) => {
        //// console.log("dataTmp GetJobPosted")
        //// console.log(dataTmp)
        let filter_data = {"isDeleted": "0", "companyId" : dataTmp[0].companyId}
        let JobPostedTmp = []
        const Params = {
          "_collection" : "JobPosting",
          "filter_data" : filter_data
        }
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            let data = res.data
            let newstr2=""
            data.JobPosting.map(function(itm,i){
                let strJson = "{" + itm.substring(46, itm.length)
                let strJson2 = itm.substring(18, itm.length)
                newstr2 = strJson2.split("')")[0]
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                json.headerId = newstr2
                JobPostedTmp.push(json)
            })       
            //// console.log("JobPostedTmp GetJobPosted")
            //// console.log(JobPostedTmp)

            setjobPosted(JobPostedTmp)
            
            // setJson(dataTmp)  
        })
        .catch(error =>{
            alert("error: " + error)
        })
    };

 
  
    /* Get items */
    async function OnLoadScreen(){
        // setJobType("")
        // setCategory("")
        // setJobOverviewLocation("")
        // setOfferedSalary("")
        // setPosted("")
        // setExperience("")
        // setGender("0")
        // setIndustry("")
        // setQualification("")
        // setLevel("")
        // setApplied("")
    }

    const rowEvents = {
      /*   onClick: (e, row, rowIndex) => {
            //// console.log("onClick")
            //// console.log(rowIndex)
            //handleView(row)
           
        }, */
     
    };

    const handleViewResume=(row)=>{
        //// console.log("handleViewResume")
        //// console.log(row)
        sessionStorage.setItem("viewProfile", JSON.stringify(row.employeeId))
        window.location.href='/AppFormView'
      
    }

    const handleDownloadResume=(row)=>{
        //// console.log("handleDownloadResume")
        //// console.log(row)
        //sessionStorage.setItem("jobPostedEdit", JSON.stringify(row))
       // window.location.href='/CreateJobPosting'
      
    }

    const GridDataModified=(oldValue, newValue, headerId, column , index)=>{
        mainGrid.map(function(item,i,index) {
            if (item.headerId === headerId){
                item.isModified = newValue!=oldValue ? "1" : "0"
               /*  // console.log("GridDataModified item")
                // console.log(item.isModified)
                // console.log(item.headerId) */
                setisshow(false)
                if(item.isModified == "1"){
                    console.log(item)
                    item.status = newValue === "Hired" ? "Process" : newValue
                    item.procStatus = newValue === "Hired" ? "Hired" : ""
                    item.isModified = "0"
                    item.dateHired = newValue === "Hired" ?  moment(new Date()) .format("MM/DD/YYYY") : ""
                    item.dateStart = newValue === "Hired" ?  moment(new Date()) .format("MM/DD/YYYY") : ""
                    saveGrid(item)
                 
                }
               
                
                
            }
        })
    }

    const saveGrid=(item)=>{

        const updateParams = {
    
            "_collection" : "Candidates",
            "doc_data"    : item,
            "_id"         : item.headerId,
      
        }

    
        console.log("saveGrid updateParams")
        console.log(updateParams)
      
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/update_one", updateParams)
        .then(res => {
            let data = res.data
            
            console.log("update_one data")
            console.log(data)
            console.log("update_one data end")
          
        
        }).catch(error =>{
            
            console.log("error: " + error)
          
    
        })
    }

    const onChangejobRef = (e) => {
        setjobRef(e.target.value)
    }
    const onChangepstingDateFilter = (e) => {
        setpstingDateFilter(e.target.value)
    }
    const onChangejobPostStatus = (e) => {
        setjobPostStatus(e.target.value)
    }
    const onChangejobtitlefilter = (e) => {
        setjobtitlefilter(e.target.value)
    }
    const onChangeendDateFilter = (e) => {
        setendDateFilter(e.target.value)
    }

    const columns = [
        {

            dataField   : 'postingId',
            text        : 'Job Post Reference',
            editable:false,
            headerStyle : () => {
            
                return { width  : "20%", color:"green", fontWeight : "bold" };
            },
            style:{ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" }

        },
        {

            dataField   : 'title',
            text        : 'Job Title',
            editable:false,
            headerStyle : () => {
                return { width  : "20%", color:"green", fontWeight : "bold" };
            },
            style:{ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" }
            

        },
        {

            dataField   : 'name',
            text        : 'Name of Candidate',
            editable:false,
            headerStyle : () => {
                return { width  : "10%", color:"green", fontWeight : "bold" };
            },
            style:{ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" }
            

        },
        {

            dataField   : 'expectedSalary',
            text        : 'Expected Salary',
            editable:false,
            headerStyle : () => {
                return { width  : "10%", color:"green", fontWeight : "bold" };
            },
            style:{ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" }
            

        },
        {

            dataField   : 'city',
            text        : 'City',
            editable:false,
            headerStyle : () => {
                return { width  : "10%", color:"green", fontWeight : "bold" };
            },
            style:{ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" }
            

        },
        {

            dataField   : 'dateStart',
            text        : 'Start Date',
            editable:true,
            headerStyle : () => {
                return { width  : "10%", color:"green", fontWeight : "bold" };
            },
            style:{ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" },   
            editor: {
              type: Type.DATE
            }
            

        },
        {

            dataField   : 'dateHired',
            text        : 'Hired Date',
            editable:true,
            headerStyle : () => {
                return { width  : "10%", color:"green", fontWeight : "bold" };
            },
            style:{ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" },
            editor: {
                type: Type.DATE
            },
            

        },
        {

            dataField   : 'resume',
            text        : 'Resume',
            editable:false,
            classes: 'demo-key-row',
            headerStyle : () => {
                return { width  : "10%", color:"green", fontWeight : "bold" };
            },
            style:{whiteSpace: 'nowrap',color:"green",fontStyle:"bold" },
            formatter   :   (cell, row, isSelect) => {
                if(row)
                return (
                    //<div>
                        //<button color="link" style={{border:"none",backgroundColor:"#41970e",color:"000000",marginRight:"5%" ,border: "1px solid black"}} variant="link" onClick={e => handleViewResume(row)}>
                            //<ImEye />
                        //</button>&nbsp;&nbsp;&nbsp;
                        //<button color="link" style={{marginLeft:"10px",border:"none",backgroundColor:"#41970e",color:"000000",border: "1px solid black"}}  variant="link" onClick={e => handleDownloadResume(row)}>
                            //<FiDownload />
                        //</button>
                    //</div>
                    <div>
                        <button color="link" style={{border:"none",background:"#ffffff",color:"green",marginLeft:"-15"}} variant="link" onClick={e => handleViewResume(row)}>
                            {<i>View</i>}
                        </button>&nbsp;
                        <button color="link" style={{marginLeft:"10px",border:"none",background:"#ffffff",color:"green"}}  variant="link" onClick={e => handleDownloadResume(row)}>
                            { <i>Download</i>}
                        </button>
                    </div>

                );
            },

        },
        {
            dataField   : 'status',
            text        : 'Status',
            editable:true,
            headerStyle : () => {
                return { width  : "10%", color:"green", fontWeight : "bold" };
            },
            style:{/* textAlign: 'right', */ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000"},
            editor: {
                type: Type.SELECT,
                options: statusData
            },
        },
        {

            dataField   : 'remarks',
            text        : 'Remarks',
            editable:true,
            headerStyle : () => {
                return { width  : "30%", color:"green", fontWeight : "bold" };
            },
            style:{ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" }
            

        },
        
       
    ]

    const selectRow = {
        mode: 'checkbox',
        clickToSelectAndEditCell: false,
        // hideSelectColumn: false,
        onSelect: (row, isSelect, rowIndex, e) => {
            let disable = true
            mainGrid.map(function(item,i){
                if(item.headerId===row.headerId)
                {
                    // console.log(row)
                    item.isDeleted = isSelect ? "1" : "0"
                }
            })
        },
        onSelectAll: (isSelected, row) => {
            // console.log(isSelected)
            // if (isSelected) {
            mainGrid.forEach(item =>{
                item.isDeleted = isSelected === true ? "1" : "0"
            })
            // } 
        }

    
    };

    const onCLickProcess = () =>{
        // alert("qwerty")

        // console.log("mainGrid")
        // console.log(mainGrid)

        let fltrSlctd = mainGrid.filter(x=>x.isDeleted === "1") 
        if(fltrSlctd.length === 0){

            setalerttype("Danger!")
            setisshow(true)
            setcolor("danger")
            setmessagealert("Please select atleast 1 to process.")
            setfade(true)
            return
        }
        // console.log("filterStatus")
        // console.log(filterStatus)

        let slctdList = fltrSlctd.filter(x=>x.procStatus !== "" && x.dateHired !== "" && x.dateStart !== "")
        // console.log("slctdList")
        // console.log(slctdList)

        if(slctdList.length === 0){

            setalerttype("Danger!")
            setisshow(true)
            setcolor("danger")
            setmessagealert("Status, hired date and start date required.")
            setfade(true)
            return
        }


        slctdList.map(function(item,i){

            // console.log(item)

            let obj = {

                IsProcess : item.IsProcess,
                city : item.city,
                companyCode : item.companyCode,
                companyName : item.companyName,
                createdBy : item.createdBy,
                createdDate : item.createdDate,
                dataPrivacy : item.dataPrivacy,
                dateApplied : item.dateApplied,
                educLevel : item.educLevel,
                email : item.email,
                employeeId : item.employeeId,
                employementType : item.employementType,
                endDate : item.endDate,
                expectedSalary : item.expectedSalary,
                experience : item.experience,
                headerId : item.headerId,
                industry : item.industry,
                isDeleted : "0",
                isModified : item.isModified,
                isPhr : item.isPhr,
                isRegister : item.isRegister,
                isResume : item.isResume,
                jobDepartment : item.jobDepartment,
                jobDocNo : item.jobDocNo,
                level : item.level,
                message : item.message,
                modifiedDate : item.modifiedDate,
                modifiedby : item.modifiedby,
                name : item.name,
                newId : item.newId,
                postingId : item.postingId,
                procStatus : item.procStatus,
                qualification : item.qualification,
                resume : item.resume,
                status : "Process",
                title : item.title,
                dateHired : item.dateHired,
                remarks : item.remarks,
                dateStart : item.dateStart,
                
            }

            const updateParams = {
        
                "_collection" : "Candidates",
                "doc_data"    : obj,
                "_id"         : item.headerId,
        
            }

        
            // console.log("updateParams")
            // console.log(updateParams)
        
            axios
            .post(AppConfiguration.Setting().jobspaceapi + "action/update_one", updateParams)
            .then(res => {
                let data = res.data
                
                // // // // console.log("update_one data")
                // // // // console.log(data)
                // // // // console.log("update_one data end")
                GetCandidates()
            
            
            })
            .catch(error =>{
                
                // // // // console.log("error: " + error)
            
        
            })

        })

        
    }

    return (
        <React.Fragment>
            <Card className="job-detail overflow-hidden mt-1" >
                <CardBody className="p-4" style={{ marginTop : "3%"}}>
                    <Row>
                        <Col lg={1}></Col>
                        <Col lg={10}>
                            <Alert isOpen={isshow} color={color} fade={fade} className={isshow ? 'display-block' : 'display-none'} style={{maxWidth: "100%"}}>
                                <div className={color}></div> 
                                <b>{messageAlert}</b>
                            </Alert>
                            <Label className="mt-3" style={{color:"#0A6219", fontSize: "20px", fontWeight: "bold", marginTop:"25px"}}>Short Listed Candidates</Label><br />
                            <Card className="mt-1" style={{ borderColor: "green"}}>
                                <Row className="mt-2">
                                    <Col lg={1}>
                                    </Col>
                                    <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px', color:"#0A6219", fontSize: "14px", fontWeight: "bold"}}>Job Post Reference : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-55px"/* marginBottom:"5px",background:"#F0FEED" */}}
                                            value={jobRef}
                                            onChange={onChangejobRef}
                                                
                                        />
                                    </Col>
                                    <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px',color:"#0A6219" , fontSize: "14px", fontWeight: "bold"}}>Posted Date : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="date"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-85px"/* marginBottom:"5px",background:"#F0FEED" */}}
                                            value={pstingDateFilter}
                                            onChange={onChangepstingDateFilter}
                                                
                                        />
                                    </Col>
                                    {/* <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px',color:"#0A6219" , fontSize: "14px"}}>Job Post Status : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-85px"}}
                                            value={jobPostStatus}
                                            onChange={onChangejobPostStatus}
                                                
                                        />
                                    </Col> */}
                                    
                                </Row>
                                <Row className="mt-3"  style={{  marginBottom:"20px",}}>
                                    <Col lg={1}>
                                    </Col>
                                    <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px', color:"#0A6219" , fontSize: "14px", fontWeight: "bold"}}>Job Title : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-55px"/* marginBottom:"5px",background:"#F0FEED" */}}
                                            value={jobtitlefilter}
                                            onChange={onChangejobtitlefilter}
                                                
                                        />
                                    </Col>
                                    <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px',color:"#0A6219" , fontSize: "14px", fontWeight: "bold"}}>End Date : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="date"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-85px"/* marginBottom:"5px",background:"#F0FEED" */}}
                                            value={endDateFilter}
                                            onChange={onChangeendDateFilter}
                                        />
                                    </Col>
                                    {/* <Col lg={2}>
                                        <button type="submit" className="btn-success noser-button-md" onClick={handleChangeSearch} style={{minWidth : "10%", textAlign: "center", marginRight : "2%", backgroundColor: "transparent", border: "2px solid green", fontWeight: "bold", color : "white"}}>
                                            Search
                                        </button>
                                        <button type="submit" className="noser-button-md" onClick={() => window.location.reload(true)} style={{minWidth : "10%", textAlign: "center", backgroundColor: "transparent", border: "1px solid green", fontWeight: "bold", color : "green"}}>
                                            Clear
                                        </button>
                                    </Col> */}
                                    <Col lg={2}>
                                        <button type="submit" className="btn-success noser-button-md" onClick={handleChangeSearch} style={{minWidth : "10%", textAlign: "center", marginRight : "2%", backgroundColor: "green", border: "2px solid green", fontWeight: "bold", color : "white"}}>
                                            Search
                                        </button>
                                        <button type="submit" className="noser-button-md" onClick={() => window.location.reload(true)} style={{minWidth : "10%", textAlign: "center", backgroundColor: "transparent", border: "1px solid green", fontWeight: "bold", color : "green"}}>
                                            Clear
                                        </button>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col lg={1}></Col>
                    </Row>
                    <Row>
                        <Col lg={1}></Col>
                        <Col lg={10}>
                            <Card className="mt-2" style={{ borderColor: "green"}}>
                                <CardBody style={{overflowY: "auto"}}>
                                    <div >
                                        <BootstrapTable
                                            keyField="headerId"
                                            data={ mainGrid.filter(x=>x.status === "SL" && x.procStatus === "").sort((a, b) => a.id < b.id ? 1 : -1)  }
                                            columns={ columns }
                                            bordered={ false }
                                            rowEvents={ rowEvents }
                                            noDataIndication={ () => <div>No record found.</div> }
                                            cellEdit = { cellEditFactory({
                                                mode: 'dbclick',
                                                blurToSave: true,
                                                afterSaveCell: (oldValue, newValue, row, column) => {
                                                    GridDataModified(oldValue, newValue, row.headerId, column.dataField , row)
                                                    }
                                                })
                                            }
                                            selectRow = { selectRow }
                                            //striped
                                            hover
                                            condensed
                                        />
                                    </div>
                                    <Row>
                                        <Col sm={11}>
                                        </Col>
                                        <Col sm={1}>
                                            <button type="submit" className="btn-success noser-button-md" onClick={onCLickProcess} style={{minWidth : "10%", textAlign: "center", marginRight : "2%", backgroundColor: "green", border: "2px solid green", fontWeight: "bold", color : "white"}}>
                                                Process
                                            </button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg={1}></Col>
                    </Row>
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default ShortListed;
